import {Observable} from 'rxjs';
import {BrowserXhr, Request, Response, ResponseOptions, XHRBackend, XHRConnection, XSRFStrategy} from '@angular/http';
import {getClientErrorResponse} from "./entity/client.error.factory";

export class ClientXhrBackend extends XHRBackend {

    constructor(browser: BrowserXhr, options: ResponseOptions, strategy: XSRFStrategy) {
        super(browser, options, strategy);
    }

    createConnection(request: Request): XHRConnection {
        let connection = super.createConnection(request);
        connection.response = this.wrapObservable(connection.response);
        return connection;
    }

    private wrapObservable(response: Observable<Response>): Observable<Response> {
        return Observable.create((observer) => {
            response.subscribe(
                (value) => {
                    observer.next(value)
                },

                (error: Response) => {
                    observer.error(getClientErrorResponse(error));
                },

                () => {
                    observer.complete()
                }
            );
        })
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/clients/app/core/http/client.xhr.backend.ts